import axios from "@/utils/axios";
import { GetAllTeamsResponse } from "@/api/admin/get-all-teams.response";

export default {
	async getUsers(): Promise<any[]> {
		return (await axios().get("/admin/users/")).data;
	},
	async getSubscribedUsers(): Promise<any[]> {
		return (await axios().get("/admin/subscribed-users/")).data;
	},
	async getTeams(): Promise<GetAllTeamsResponse> {
		return (await axios().get("/admin/teams/")).data;
	},
	async getSyncTasks(): Promise<any[]> {
		return (await axios().get("/admin/synctasks/")).data;
	}
};